import React, { useEffect, useMemo, useState } from "react";
import CardsBorder from "../../../components/Cards/CardsBorder";
// import SearchBar from "../../../components/Elements/Search/SearchBar";
import { Tables } from "../../../components/Elements/Tables/Tables";
import { ReactComponent as EyeIcon } from "../../../assets/svgs/eye-icon.svg";
import { fetchGroupUnderClient } from "../../../redux/customer/customerSlice";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
const CustomerGroup = () => {
  // const [seacrhItem, setSearchItem] = useState("");
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  //---user ID from params-----
  const { userId } = useParams() ;
  //--Redux State--
  const { customerGroup } = useSelector((state) => state.customer);

  //----API CALL---
  useEffect(() => {
    if (userId) {
      dispatch(fetchGroupUnderClient(userId));
    }
  }, [dispatch, userId]);

  const headers = useMemo(
    () => [
      { label: "Sr. No.", key: "serial" },
      { label: "Group Name", key: "groupName" },
      { label: "Group ID", key: "groupId" },
      { label: "CreatedOn", key: "createdOn" },
      { label: "Action", key: "action" },
    ],
    [],
  );
  const tableData = useMemo(() => {
    if (customerGroup == "") return [];

    return [
      {
        serial: 1,
        groupName: customerGroup.groupName || "",
        groupId: customerGroup.groupOffsetId || "",
        createdOn: customerGroup.createdAt
          ? new Date(customerGroup.createdAt).toLocaleDateString()
          : "",
        validTill: customerGroup.validTill
          ? new Date(customerGroup.validTill).toLocaleDateString()
          : "",
        action: (
          <div className="flex gap-3 justify-center items-center">
            <EyeIcon
              style={{ cursor: "pointer" }}
              onClick={() =>
                navigate(`/group/group-page`, {
                  state: {
                    from: location.pathname,
                    groupId: customerGroup.groupId,
                  },
                })
              }
            />
          </div>
        ),
      },
    ];
  }, [customerGroup]);
  return (
    <div
      style={{ paddingLeft: "40px", paddingRight: "40px", paddingTop: "20px" }}
    >
      <CardsBorder>
        <div className="flex gap-8 my-2 font-medium">
          <p className="text-[#06513D] pt-2 px-10 text-xl">Groups</p>
          {/* <SearchBar width="300px" onSearch={setSearchItem} /> */}
        </div>
        <Tables data={tableData} headers={headers} />
      </CardsBorder>
    </div>
  );
};

export default CustomerGroup;
